



















import { computed, defineComponent } from '@vue/composition-api';

import getProductGroups from '@/gql/product/getProductGroups.gql';

const CommonProductTypeSelect = defineComponent({
  props: {
    label: {
      type: String,
      default() { return 'พื้นที่จัดส่ง'; },
    },
    value: {},
    level: {},
    showLabel: { default: false },
    rules: { default: '' },
    multiple: { default: false },
    optionLabel: {},
    placeholder: {},
  },
  setup(props: any) {
    const _value = computed(() => props.value);
    return {
      _value,

      getProductGroups,
      result: (data: any) => data.productGroups.data,
    };
  },
});

export default CommonProductTypeSelect;
